import React from 'react';
import * as S from './GameSection.styles';

/**
 * Reusable section container for game pages and landing sections.
 */
const GameSection = ({
  title,
  subtitle,
  children,
  background,
  align = 'center',
  id,
  className,
}) => {
  return (
    <S.SectionContainer $background={background} id={id} className={className}>
      <S.InnerContainer>
        {(title || subtitle) && (
          <S.Header $align={align}>
            {title && <S.Title>{title}</S.Title>}
            {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
          </S.Header>
        )}
        {children}
      </S.InnerContainer>
    </S.SectionContainer>
  );
};

export default GameSection;
